import React from 'react';
import './GoldenDeleteConfirmation.css';

const GoldenDeleteConfirmation = ({ 
  isOpen, 
  onClose, 
  onConfirm, 
  title = "Are you sure you want to delete this user?",
  message = "This action cannot be undone. The user and all associated data will be permanently removed.",
  confirmText = "Yes, Delete User",
  cancelText = "Cancel",
  isLoading = false,
  userInfo = null
}) => {
  if (!isOpen) return null;

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  const handleConfirm = () => {
    onConfirm();
  };

  return (
    <div className="golden-delete-modal-backdrop" onClick={handleBackdropClick}>
      <div className="golden-delete-modal">
        {/* Golden Header */}
        <div className="golden-modal-header">
          <div className="golden-icon-container">
            <div className="golden-warning-icon">
              <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path 
                  d="M12 9V13M12 17H12.01M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" 
                  stroke="currentColor" 
                  strokeWidth="2" 
                  strokeLinecap="round" 
                  strokeLinejoin="round"
                />
              </svg>
            </div>
            <div className="golden-sparkles">
              <div className="sparkle sparkle-1">✨</div>
              <div className="sparkle sparkle-2">✨</div>
              <div className="sparkle sparkle-3">✨</div>
              <div className="sparkle sparkle-4">✨</div>
            </div>
          </div>
        </div>

        {/* Golden Content */}
        <div className="golden-modal-content">
          <h2 className="golden-modal-title">{title}</h2>
          <p className="golden-modal-message">{message}</p>
          
          {/* User Info Display */}
          {userInfo && (
            <div className="golden-user-info">
              <div className="user-info-header">
                <h3>User Details</h3>
              </div>
              <div className="user-info-content">
                <div className="user-info-item">
                  <strong>Name:</strong> {userInfo.name}
                </div>
                <div className="user-info-item">
                  <strong>Email:</strong> {userInfo.email}
                </div>
                <div className="user-info-item">
                  <strong>Role:</strong> 
                  <span className={`role-badge ${userInfo.role}`}>
                    {userInfo.role}
                  </span>
                </div>
              </div>
            </div>
          )}
          
          {/* Golden Warning Box */}
          <div className="golden-warning-box">
            <div className="warning-icon">⚠️</div>
            <div className="warning-content">
              <strong>Warning:</strong> This action is irreversible and will permanently delete:
              <ul>
                <li>User account and profile</li>
                <li>All user orders and history</li>
                <li>User preferences and settings</li>
                <li>Associated data and analytics</li>
              </ul>
            </div>
          </div>
        </div>

        {/* Golden Actions */}
        <div className="golden-modal-actions">
          <button 
            className="golden-btn golden-btn-cancel" 
            onClick={onClose}
            disabled={isLoading}
          >
            <span className="btn-icon">🚫</span>
            <span className="btn-text">{cancelText}</span>
          </button>
          
          <button 
            className="golden-btn golden-btn-delete" 
            onClick={handleConfirm}
            disabled={isLoading}
          >
            {isLoading ? (
              <>
                <div className="golden-spinner"></div>
                <span className="btn-text">Deleting...</span>
              </>
            ) : (
              <>
                <span className="btn-icon">🗑️</span>
                <span className="btn-text">{confirmText}</span>
              </>
            )}
          </button>
        </div>

        {/* Golden Border Animation */}
        <div className="golden-border-animation">
          <div className="border-glow"></div>
        </div>
      </div>
    </div>
  );
};

export default GoldenDeleteConfirmation;
